import React, { FC } from 'react'

import Container from 'react-bootstrap/Container'

import {
    companyNameFull,
    preferedName,
    dataPortalTitle
} from '../../assets/i18n/i18n'

import PageTitle from '../PageTitle'

const PrivacyNotice: FC = () => {
    return (
        <section className='content'>
            <Container>
                <PageTitle displayName="Member Privacy Notice" />

                <h1 className='headerText h2'>
                    Member Privacy Notice
                </h1>

                <p>
                    <strong>Effective Date:</strong> September 22, 2026
                    <br />
                    <strong>Date Last Updated:</strong> September 22, 2026
                </p>

                <h2 className='h3'>1. Information We Collect</h2>

                <p>
                    As your health plan, {companyNameFull} collects personal
                    and health information necessary to manage your coverage
                    and display your records in the ConnectID {preferedName}{' '}
                    {dataPortalTitle} (&quot;Portal&quot;). This includes your
                    name, contact details, member ID, plan options, claims
                    history, and Explanation of Benefits (EOBs).
                </p>

                <h2 className='h3'>
                    2. How We Use and Share Your Information
                </h2>

                <ul>
                    <li>
                        We use your information to manage your health benefits,
                        display claims data, verify your identity, and provide
                        customer support.
                    </li>

                    <li>
                        We share data with our secure technology platform
                        providers—HealthLX and TESCHGlobal—solely to host,
                        operate, and maintain the Portal. We do not sell your
                        personal or health data.
                    </li>
                </ul>

                <h2 className='h3'>
                    3. HIPAA &amp; Privacy Rights
                </h2>

                <p>
                    Your Protected Health Information (PHI) is protected under
                    the Health Insurance Portability and Accountability Act
                    (HIPAA). {companyNameFull} maintains physical, electronic,
                    and procedural safeguards to secure your PHI.
                </p>

                <h2 className='h3'>4. Your Rights</h2>

                <p>
                    You have the right to inspect your health plan data,
                    request corrections to your member record, and request an
                    accounting of certain disclosures. For questions or privacy
                    requests, contact {companyNameFull} support.
                </p>
            </Container>
        </section>
    )
}

export default PrivacyNotice